var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVybogTalgenIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87485 7.54181C7.38474 7.54181 7.79809 7.12846 7.79809 6.61856C7.79809 6.10866 7.38474 5.69531 6.87485 5.69531C6.36495 5.69531 5.9516 6.10866 5.9516 6.61856C5.9516 7.12846 6.36495 7.54181 6.87485 7.54181Z",
    fill: "#2064ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9738 2.26104H13.1391C13.1391 2.26104 11.8027 2.15225 11.1294 3.19752C10.8104 3.69296 9.21969 6.09664 8.07592 7.82111C7.95831 7.999 7.98771 8.23275 8.14208 8.37976C8.51549 8.7326 8.74189 9.23685 8.72278 9.79551C8.68897 10.7526 7.91567 11.5332 6.95861 11.5788C5.8957 11.6273 5.01803 10.7805 5.01803 9.72788C5.01803 9.19863 5.24002 8.72083 5.59579 8.38417C5.74722 8.24157 5.76927 8.00929 5.65313 7.83728L4.92541 6.76702C4.6799 6.35244 4.29766 6.03195 3.84192 5.88053C3.64639 5.81584 3.42146 5.77321 3.17006 5.77321H1.03689C1.03689 5.77321 0.462068 5.72175 0.822252 6.31863L4.23739 11.6758C4.65491 12.3036 5.29148 13.2812 6.22207 13.6443C6.64694 13.8105 7.2203 13.7561 7.64664 13.5591C8.44493 13.1901 8.89332 12.5432 9.2241 12.0536L15.2384 2.71237C15.2384 2.71237 15.481 2.26104 14.9738 2.26104Z",
    fill: "#2064ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3091 10.2422C3.53023 10.3745 2.66138 9.18808 2.66138 9.18808C2.66138 9.18808 4.20061 11.605 4.49023 12.0402C4.77985 12.4753 5.50022 13.3603 6.22205 13.6426C6.64693 13.8087 7.27761 13.7264 7.70396 13.5294C8.50224 13.1604 9.00356 12.415 9.22555 12.0534L12.1394 7.52242C12.1394 7.52242 11.3558 7.43421 8.78304 8.97491C6.74689 10.1951 6.29115 10.1716 5.31057 10.2436L5.3091 10.2422Z",
    fill: "#2064ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_802",
    x: 0.572392,
    y: 5.08433,
    width: 13.656,
    height: 10.3879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.348164
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_802"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_802",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVybogTalgenIconBlue);
export default __webpack_public_path__ + "static/media/VybogTAL GEN Icon Blue.e714ba87e7b6b52008f93c94d0931e91.svg";
export { ForwardRef as ReactComponent };